/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ExchangeCancelCategory } from './exchange-cancel-category';
// May contain unused imports in some cases
// @ts-ignore
import type { ExposeBankAccount } from './expose-bank-account';

/**
 * 
 * @export
 * @interface PostExchangeDataDto
 */
export interface PostExchangeDataDto {
    /**
     * 환급 uuid
     * @type {string}
     * @memberof PostExchangeDataDto
     */
    'exchangeUuid': string;
    /**
     * 환급 신청 금액
     * @type {number}
     * @memberof PostExchangeDataDto
     */
    'amountRequested': number;
    /**
     * 환급 상태
     * @type {string}
     * @memberof PostExchangeDataDto
     */
    'status': PostExchangeDataDtoStatusEnum;
    /**
     * 생성 일시
     * @type {string}
     * @memberof PostExchangeDataDto
     */
    'createdAt': string;
    /**
     * 기타 환급 불가 사유
     * @type {string}
     * @memberof PostExchangeDataDto
     */
    'exchangeCancelOtherReason': string;
    /**
     * 환급 (예정) 일시
     * @type {string}
     * @memberof PostExchangeDataDto
     */
    'exchangeAt': string;
    /**
     * 취소 여부
     * @type {boolean}
     * @memberof PostExchangeDataDto
     */
    'isCancelled': boolean;
    /**
     * 환급 불가 사유
     * @type {ExchangeCancelCategory}
     * @memberof PostExchangeDataDto
     */
    'exchangeCancelCategory': ExchangeCancelCategory;
    /**
     * 노출용 계좌 정보
     * @type {ExposeBankAccount}
     * @memberof PostExchangeDataDto
     */
    'exposeBankAccount': ExposeBankAccount;
}

export const PostExchangeDataDtoStatusEnum = {
    Application: 'application',
    Waiting: 'waiting',
    Completed: 'completed',
    Impossible: 'impossible'
} as const;

export type PostExchangeDataDtoStatusEnum = typeof PostExchangeDataDtoStatusEnum[keyof typeof PostExchangeDataDtoStatusEnum];


